import BaseComponent from '@/components/base';
import { FontStyle } from '@/components/style';
import fragranceStyle from '@/components/regimen/fragrance-select/style';
import { fragranceMap } from '@/utils/fragrance-map';

export default class FragranceSelect extends BaseComponent {
  selectedCard = '';
  isSOS = false;
  rightArrow = `
    <div class="right-arrow" style="padding-left: 24px;    padding-bottom: 40px;">
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="24" viewBox="0 0 13 24" fill="none">
            <path d="M1 22.5L11 12L1 1.5" stroke="#3A3E43" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
    </div>
  `;
  leftArrow = `
    <dvi class="left-arrow" style="padding-right:24px;    padding-bottom: 40px;">
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="24" viewBox="0 0 13 24" fill="none">
            <path d="M12 1.5L2 12L12 22.5" stroke="#3A3E43" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
    </dvi>
  `;

  get cards() {
    return [...fragranceMap];
  }

  render() {
    const urlParams = new URLSearchParams(window.location.search);
    const profileType = urlParams.get('product_type');

    const isSmallScreen = this.isSmall || this.enableSmallView;
    const isFilterRecovery =
      profileType === 'recovery' || this.isSOS || this.isRecovery;

    const showArrows =
      !isFilterRecovery &&
      !isSmallScreen &&
      this.getAttribute('hide-arrows') != '';

    const fragrancesCarousel = `
     <div>
            <div class="card-container" style="${
              isSmallScreen
                ? 'width: 360px; justify-content: unset;'
                : `width: 750px;  justify-content: unset;scroll-snap-type: x mandatory;scroll-behavior: smooth; white-space: nowrap;`
            } ${showArrows ? 'overflow-x: auto;' : ''}">
                ${this.cards
                  ?.filter((x) => {
                    if (
                      profileType === 'recovery' ||
                      this.isSOS ||
                      this.isRecovery
                    ) {
                      return x.type === 'recovery';
                    }
                    return true;
                  })
                  ?.map(
                    (card) =>
                      `<div class="card" description="${card.description}" name="${card.name}" value="${card.dataKey}">
                    <div class="card-image" style="background-image: url('${card.image}');"></div>
                    <div class="card-image-description">${card.name}</div>
                   </div>`
                  )
                  ?.join('')}

            </div>
            <div id="testFrag" class="description body-font-1" style="height: 40px"></div>
        </div>
    `;

    return `
    ${fragranceStyle({
      isSmall: this.isSmall,
      enableSmallView: this.enableSmallView
    })}
    ${FontStyle}
    <div class="container">
    ${
      !this.enableBaseCarousel
        ? `<div class="body-font-4" style="padding-bottom: 24px">step 2</div>
        <div class="title-font-5" style="padding-bottom: 40px; text-align: center;">Select Your Fragrance</div>`
        : ''
    }

        ${
          showArrows
            ? `
          <div style="display: flex; flex-direction: row; align-items: center">
            ${this.leftArrow}
            ${fragrancesCarousel}
            ${this.rightArrow}

          </div>
        `
            : fragrancesCarousel
        }

    </div>

    `;
  }

  get enableBaseCarousel() {
    return this.getAttribute('enable-base') === 'true';
  }

  get enableSmallView() {
    return this.getAttribute('enable-small') === 'true';
  }

  get isRecovery() {
    return this.getAttribute('is-recovery') === 'true';
  }

  enableSOS(value) {
    this.isSOS = value;
    this.connectedCallback();
  }

  ChangeSelectedCard(value) {
    this.selectedCard = value;
  }

  onConnect() {
    this.shadowRoot.addEventListener('click', (event) => {
      if (
        event.target?.parentNode?.classList?.contains('card') &&
        event.target.classList[0].includes('card')
      ) {
        this.shadowRoot.querySelectorAll('.card').forEach((x) => {
          x.style.border = '1px solid #E6E8E8';
          x.querySelector('.card-image-description').style.backgroundColor =
            '#FCFAF5';
        });

        event.target.parentNode.style.border = '1.5px solid #8AE5D3';
        event.target.parentNode.style.backgroundColor = '#F1F9F7';
        event.target.parentNode.querySelector(
          '.card-image-description'
        ).style.backgroundColor = '#F1F9F7';

        const description = event.target.parentNode.getAttribute('description');
        const value = event.target.parentNode.getAttribute('value');

        this.selectedCard = value;
        description &&
          (this.shadowRoot.querySelector('.description').innerText =
            description) &&
          (this.shadowRoot.querySelector('.description').style.color = 'black');
        var _learnq = window._learnq || [];
        _learnq.push([
          'identify',
          {
            profile_hair_fragrance: value,
            profile_hair_fragrance_strength: 'medium'
          }
        ]);
      }
    });
  }

  afterMount() {
    const arrowLeft = this.shadowRoot.querySelector('.left-arrow');
    const arrowRight = this.shadowRoot.querySelector('.right-arrow');
    const cardContainer = this.shadowRoot.querySelector('.card-container');
    arrowLeft &&
      arrowLeft.addEventListener('click', () => {
        console.log('holaaaaa leftt');
        cardContainer.scrollLeft -= 300;
        // cardContainer.scrollTo({
        //   right: 100,
        //   behavior: 'smooth'
        // });
      });

    arrowRight &&
      arrowRight.addEventListener('click', () => {
        console.log('holaaaaa left');
        cardContainer.scrollLeft += 300;
      });
  }

  onError(e) {
    const descriptionElement = this.shadowRoot.querySelector('.description');
    descriptionElement.innerText = e;
    descriptionElement.style.color = '#D91022';

    this.shadowRoot.querySelectorAll('.card').forEach((x) => {
      x.style.border = '1px solid #D91022';
    });

    return true;
  }
}
